function initSelectState() {
  const selects = document.querySelectorAll('.form-lined select.freeform-input')

  selects.forEach(select => {
    const updateState = () => {
      select.classList.toggle('has-value', select.value !== '')
    }

    select.addEventListener('change', updateState)
    updateState()
  })
}

export default {
  init: initSelectState,
  destroy: () => {}
}
